import moment from "moment/moment";
import * as Yup from "yup";

export const AddCourseSchema = Yup.object().shape({
    course_type: Yup.string().required("Select Learning Module Type"),
    availability: Yup.string().required("Select Availability"),
    course_title: Yup.string().required("Enter Learning Module Title"),
    course_id: Yup.string().required("Enter Learning Module ID"),
    // cover: Yup.mixed().required('Choose File'),
    thumb: Yup.mixed().required('Choose File'),
    duration: Yup.number().typeError("Enter Only Number").required("Enter Duration").positive("Enter Only Positive Number").integer("Enter Only Integer Number"),
    department: Yup.array().required("Select Permission To").min(1, " Select Permission To"),
    min_time: Yup.number().typeError("Enter Only Number").required("Enter Minimum Time").positive("Enter Only Positive Number").integer("Enter Only Integer Number"),
    course_desc: Yup.string().required("Enter Learning Module Description"),

    content: Yup.array().of(
        Yup.object().shape({

            title: Yup.string().required("Enter Title"),
            source: Yup.string().required("Select Source"),

            upload: Yup.string().when("source", (val, schema) => {
                if (val == 'upload') {
                    return Yup.mixed().required('Choose File')
                } else {
                    return Yup.mixed().notRequired();
                }
            }),

            // library: Yup.string().when("source", (val, schema) => {
            //     if (val == 'library') {
            //         return Yup.string().required("Select Library")
            //     } else {
            //         return Yup.string().notRequired();
            //     }
            // }),

            link: Yup.string().when("source", (val, schema) => {
                if (val == 'link' || val == "youtube" || val == "vimeo") {
                    return Yup.string().required("Enter Key")
                } else {
                    return Yup.string().notRequired();
                }
            }),

            file: Yup.string().when("source", (val, schema) => {
                if (val == 'library') {
                    return Yup.string().required("Select File")
                } else {
                    return Yup.string().notRequired();
                }
            }),
        })
    ),

    quiz_bank: Yup.string().required("Select Quiz"),
    max_time: Yup.number().typeError("Enter Only Number").required("Enter Max. Time").positive("Enter Only Positive Number").integer("Enter Only Integer Number"),
    max_attempt: Yup.number().typeError("Enter Only Number").required("Enter Max. Attempts").positive("Enter Only Positive Number").integer("Enter Only Integer Number"),
    total_marks: Yup.number().required("Enter Total Marks"),
    passing_marks: Yup.number().required("Enter Passing Marks"),
    review: Yup.string().required("Select Review")
});

export const AddTrainingSchema = Yup.object().shape({

    training_title: Yup.string().required("Enter Training Name"),
    training_mode: Yup.string().required("Select Training Mode"),
    classroom_type: Yup.string().when("training_mode", (val, schema) => {
        if (val == 'classroom') {
            return Yup.string().required('Select Classroom')
        } else {
            return Yup.string().notRequired();
        }
    }),
    venue: Yup.string().when("classroom_type", (val, schema) => {
        if (val == 'physical') {  //if address exist then apply min max else not
            return Yup.string().required('Select Venue')
        } else {
            return Yup.string().notRequired();
        }
    }),
    instructor_name: Yup.string().required("Select Instructor Name"),
    start_date: Yup.string().when("training_mode", (val, schema) => {
        if (val == 'virtual') {
            return Yup.string().notRequired();
        } else {
            return Yup.string().required("Select Start Date")
        }
    }),
    // start_time: Yup.string().when("training_mode", (val, schema) => {
    //     if (val == 'virtual') {
    //         return Yup.string().notRequired();
    //     } else {
    //         return Yup.string().required("Select Start Time")
    //     }
    // }),
    start_time: Yup.string().when("training_mode", (val, schema) => {
        if (val == 'virtual') {
            return Yup.string().notRequired();
        } else {
            return Yup.string().required('Start time is required').test(
                'is-valid-time',
                'Start time cannot be earlier than the current time',
                function (value) {
                    const { start_date } = this.parent;
                    const selectedDate = moment(start_date, 'YYYY-MM-DD').startOf('day');
                    const today = moment().startOf('day');
                    const currentTime = moment();

                    // If the selected date is today, check if start time is valid
                    if (selectedDate.isSame(today, 'day')) {
                        const selectedTime = moment(value, 'HH:mm');
                        return selectedTime.isSameOrAfter(currentTime, 'minute');
                    }
                    return true; // No validation needed if the selected date is not today
                }
            );
        }
    }),
    // end_date: Yup.string().required("Select End Date"),
    end_date: Yup.string().when("training_mode", (val, schema) => {
        if (val == 'virtual') {
            return Yup.string().notRequired();
        } else {
            return Yup.string().required('Select End Date').test('end-date-validation',
                'End Date should not be before Start Date', function (value, context) {
                    const { start_date } = context.parent;

                    if (new Date(value) >= new Date(start_date)) {
                        return true;
                    } else {
                        return false;
                    }
                })
        }
    }),

    end_time: Yup.string().when("training_mode", (val, schema) => {
        if (val == 'virtual') {
            return Yup.string().notRequired();
        } else {
            return Yup.string().required('Select End time').test('end-time-validation', 'End time should not before Start Time ', function (value, context) {
                const { start_date, end_date, start_time } = context.parent;

                if (start_date == end_date) {
                    const startTimeDate = new Date(`1970-01-01T${start_time}`);
                    const endTimeDate = new Date(`1970-01-01T${value}`);

                    if (endTimeDate <= startTimeDate) {
                        return false
                    }
                }
                return true;
            })
        }
    }),

    training_type: Yup.string().required("Select Training Type"),

    type: Yup.string().required("Select Type"),

    learning_track: Yup.string().when("type", (val, schema) => {
        if (val == 'Learning Path') {  //if address exist then apply min max else not
            return Yup.string().required("Select Track")
        } else {
            return Yup.string().notRequired();
        }
    }),

    course_wise: Yup.array().when("type", (val, schema) => {
        if (val == 'Course Wise') {  //if address exist then apply min max else not
            return Yup.array().min(1, "Select Learning Module").required("Select Learning Module")
        } else {
            return Yup.array().notRequired();
        }
    }),

    employee: Yup.array().min(1, 'Check at Least One Rows').of(Yup.object().shape({}), 'Check at Least One Rows'),

    link: Yup.string().when("classroom_type", (val, schema) => {
        if (val == 'live') {  //if address exist then apply min max else not
            return Yup.string()
                // .matches(
                //     /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
                //     'Enter correct url!'
                // )
                .required('Enter Link')
        } else {
            return Yup.string().notRequired();
        }
    }),

    meeting: Yup.string().when("classroom_type", (val, schema) => {
        if (val == 'live') {  //if address exist then apply min max else not
            return Yup.string().required("Enter Meeting ID")
        } else {
            return Yup.string().notRequired();
        }
    }),

    password: Yup.string().when("classroom_type", (val, schema) => {
        if (val == 'live') {  //if address exist then apply min max else not
            return Yup.string().required("Enter Meeting Password")
        } else {
            return Yup.string().notRequired();
        }
    }),

    title: Yup.string().when("classroom_type", (val, schema) => {
        if (val == 'live') {  //if address exist then apply min max else not
            return Yup.string().required("Enter Meeting Title")
        } else {
            return Yup.string().notRequired();
        }
    }),

    repetation: Yup.string().required("Select Repetation"),
    repeat_count: Yup.number().when("repetation", (val, schema) => {
        if (val == 'repeat') {
            return Yup.number().typeError("Enter Only Number").required("Enter Repetation").positive("Enter Only Positive Number").integer("Enter Only Integer Number")
        } else {
            return Yup.string().notRequired();
        }
    }),
    interval_count: Yup.number().when("repetation", (val, schema) => {
        if (val == 'repeat') {
            return Yup.number().typeError("Enter Only Number").required("Enter Interval").positive("Enter Only Positive Number").integer("Enter Only Integer Number")
        } else {
            return Yup.string().notRequired();
        }
    }),


    // repeat: Yup.number().typeError("Enter Only Number").notRequired("Enter Repetation").positive("Enter Only Positive Number").integer("Enter Only Integer Number"),
    // interval: Yup.number().typeError("Enter Only Number").notRequired("Enter Interval").positive("Enter Only Positive Number").integer("Enter Only Integer Number"),

    // filter_source: Yup.string().required("Select Source"),

    // filter_group: Yup.string().when("filter_source", (val, schema) => {
    //     if (val == 'group') {  //if address exist then apply min max else not
    //         return Yup.string().required("Select Track")
    //     } else {
    //         return Yup.string().notRequired();
    //     }
    // }),

    // filter_department: Yup.array().when("filter_source", (val, schema) => {
    //     if (val == 'department') {  //if address exist then apply min max else not
    //         return Yup.array().min(1, "Select Department").required("Select Track")
    //     } else {
    //         return Yup.array().notRequired();
    //     }
    // }),

});

export const EditTrainingSchema = Yup.object().shape({

    training_title: Yup.string().required("Enter Training Name"),
    training_mode: Yup.string().required("Select Training Mode"),
    classroom_type: Yup.string().when("training_mode", (val, schema) => {
        if (val == 'classroom') {
            return Yup.string().required('Select Classroom')
        } else {
            return Yup.string().notRequired();
        }
    }),
    venue: Yup.string().when("classroom_type", (val, schema) => {
        if (val == 'physical') {  //if address exist then apply min max else not
            return Yup.string().required('Select Venue')
        } else {
            return Yup.string().notRequired();
        }
    }),
    instructor_name: Yup.string().required("Select Instructor Name"),
    start_date: Yup.string().when("training_mode", (val, schema) => {
        if (val == 'virtual') {
            return Yup.string().notRequired();
        } else {
            return Yup.string().required("Select Start Date")
        }
    }),
    // start_time: Yup.string().when("training_mode", (val, schema) => {
    //     if (val == 'virtual') {
    //         return Yup.string().notRequired();
    //     } else {
    //         return Yup.string().required("Select Start Time")
    //     }
    // }),
    start_time: Yup.string().when("training_mode", (val, schema) => {
        if (val == 'virtual') {
            return Yup.string().notRequired();
        } else {
            return Yup.string().required('Start time is required').test(
                'is-valid-time',
                'Start time cannot be earlier than the current time',
                function (value) {
                    const { start_date } = this.parent;
                    const selectedDate = moment(start_date, 'YYYY-MM-DD').startOf('day');
                    const today = moment().startOf('day');
                    const currentTime = moment();

                    // If the selected date is today, check if start time is valid
                    if (selectedDate.isSame(today, 'day')) {
                        const selectedTime = moment(value, 'HH:mm');
                        return selectedTime.isSameOrAfter(currentTime, 'minute');
                    }
                    return true; // No validation needed if the selected date is not today
                }
            );
        }
    }),
    // end_date: Yup.string().required("Select End Date"),
    end_date: Yup.string().when("training_mode", (val, schema) => {
        if (val == 'virtual') {
            return Yup.string().notRequired();
        } else {
            return Yup.string().required('Select End Date').test('end-date-validation',
                'End Date should not be before Start Date', function (value, context) {
                    const { start_date } = context.parent;

                    if (new Date(value) >= new Date(start_date)) {
                        return true;
                    } else {
                        return false;
                    }
                })
        }
    }),

    end_time: Yup.string().when("training_mode", (val, schema) => {
        if (val == 'virtual') {
            return Yup.string().notRequired();
        } else {
            return Yup.string().required('Select End time').test('end-time-validation', 'End time should not before Start Time ', function (value, context) {
                const { start_date, end_date, start_time } = context.parent;

                if (start_date == end_date) {
                    const startTimeDate = new Date(`1970-01-01T${start_time}`);
                    const endTimeDate = new Date(`1970-01-01T${value}`);

                    if (endTimeDate <= startTimeDate) {
                        return false
                    }
                }
                return true;
            })
        }
    }),

    type: Yup.string().required("Select Type"),
    training_type: Yup.string().required("Select Training Type"),
    learning_track: Yup.string().when("type", (val, schema) => {
        if (val == 'Learning path') {  //if address exist then apply min max else not
            return Yup.string().required("Select Track")
        } else {
            return Yup.string().notRequired();
        }
    }),

    course_wise: Yup.array().when("type", (val, schema) => {
        if (val == 'Course Wise') {  //if address exist then apply min max else not
            return Yup.array().min(1, "Select Learning Module").required("Select Learning Module")
        } else {
            return Yup.array().notRequired();
        }
    }),

    edit_employee: Yup.array().min(1, 'Check at Least One Rows').of(Yup.object().shape({}), 'Check at Least One Rows'),

    link: Yup.string().when("classroom_type", (val, schema) => {
        if (val == 'live') {  //if address exist then apply min max else not
            return Yup.string()
            // .matches(
            //     /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
            //     'Enter correct url!'
            // )
            .required('Enter Link')
        } else {
            return Yup.string().notRequired();
        }
    }),

    meeting: Yup.string().when("classroom_type", (val, schema) => {
        if (val == 'live') {  //if address exist then apply min max else not
            return Yup.string().required("Enter Meeting ID")
        } else {
            return Yup.string().notRequired();
        }
    }),

    password: Yup.string().when("classroom_type", (val, schema) => {
        if (val == 'live') {  //if address exist then apply min max else not
            return Yup.string().required("Enter Meeting Password")
        } else {
            return Yup.string().notRequired();
        }
    }),

    title: Yup.string().when("classroom_type", (val, schema) => {
        if (val == 'live') {  //if address exist then apply min max else not
            return Yup.string().required("Enter Meeting Title")
        } else {
            return Yup.string().notRequired();
        }
    }),

    repetation: Yup.string().required("Select Repetation"),
    repeat_count: Yup.number().when("repetation", (val, schema) => {
        if (val == 'repeat') {
            return Yup.number().typeError("Enter Only Number").required("Enter Repetation").positive("Enter Only Positive Number").integer("Enter Only Integer Number")
        } else {
            return Yup.string().notRequired();
        }
    }),
    interval_count: Yup.number().when("repetation", (val, schema) => {
        if (val == 'repeat') {
            return Yup.number().typeError("Enter Only Number").required("Enter Interval").positive("Enter Only Positive Number").integer("Enter Only Integer Number")
        } else {
            return Yup.string().notRequired();
        }
    }),

    // filter_source: Yup.string().required("Select Source"),

    // filter_group: Yup.string().when("filter_source", (val, schema) => {
    //     if (val == 'group') {  //if address exist then apply min max else not
    //         return Yup.string().required("Select Track")
    //     } else {
    //         return Yup.string().notRequired();
    //     }
    // }),

    // filter_department: Yup.array().when("filter_source", (val, schema) => {
    //     if (val == 'department') {  //if address exist then apply min max else not
    //         return Yup.array().min(1, "Select Department").required("Select Track")
    //     } else {
    //         return Yup.array().notRequired();
    //     }
    // }),

});

export const LearningTrackSchema = Yup.object({
    title: Yup.string().required("Enter Title"),
    description: Yup.string().required("Enter Description"),
    new_course: Yup.array().required("Select Learning Module").min(2, " Add atleast two Learning Module"),
});

export const CourseQuizSchema = Yup.object({
    quiz: Yup.array().of(
        Yup.object().shape({

            ans: Yup.string().required("Choose any one option"),

        })
    ),
});

export const AddAttendanceSchema = Yup.object().shape({
    attend_user: Yup.array().min(1, 'Check at Least One Row').of(Yup.object().shape({}), 'Check at Least One Row')
});

export const AddNotesSchema = Yup.object({
    notes: Yup.string().required("Enter Note"),
});

export const AddQuestionSchema = Yup.object({
    title: Yup.string().required("Enter Title"),
    description: Yup.string().required("Enter Description"),
});

export const AddExternalTrainingSchema = Yup.object({
    ext_training: Yup.string().required("Enter Training Title"),
    training_agency: Yup.string().required("Enter Training Agency"),
    program_details: Yup.string().required("Enter Training Details"),
    training_date: Yup.string().required("Select Training Date"),
    duration: Yup.number().typeError("Enter Only Number").required("Enter Training Duration").positive("Enter Only Positive Number").integer("Enter Only Integer Number"),
    ceritificate: Yup.mixed().required('Choose File'),
});

